import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { setChatInit, setIsWidget, setAppLoading, resetApp } from 'src/modules/App/actions'
import { setDisclaimer } from 'src/modules/Claims/actions'
import { setRenderedAppState } from 'src/modules/App/nonPersistentActions'
import { getFromSettings } from 'src/utils/helpers'
import AppLayout from './AppLayout'

const mapDispatchToProps = {
  setRenderedAppState,
  setIsWidget,
  setDisclaimer,
  setChatInit,
  setAppLoading,
  resetApp,
}

const mapStateToProps = state => {
  return {
    // This is not used in AppLayout but it should be passed to keep re-rendering working
    isAppRendered: state.nonPersistentAppReducer.isAppRendered,
    currentlyOpenFeature: state.appReducer.currentlyOpenFeature,
    isSidebarVisible: state.appReducer.isSidebarVisible,
    user: state.user.user,
    userLastAccessType: state.user.userLastAccessType,
    featureFlags: getFromSettings(state, 'featureFlags', []),
    bannerNotification: getFromSettings(state, 'bannerNotification', {}),
    chat: state.appReducer.chat,
    chatReset: state.chat.chatReset,
    isAppLoading: state.appReducer.isAppLoading,
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppLayout))
